<template>
  <Card v-if="proxyPerson">
    <template slot="header">Note</template>
    <v-checkbox
      v-model="person.personOfInterest"
      :disabled="!assertSetting('personEdit', 1)"
      label="Person of Interest"
    />
    <v-textarea
      v-model="person.note"
      :disabled="!assertSetting('personEdit', 1)"
      label="Note"
      outline
    />
    <v-btn
      v-if="assertSetting('personEdit', 1)"
      @click="updatePersonNote(person)"
    >
      Save
    </v-btn>
  </Card>
</template>

<script>
// import vuex mapping
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      proxyPerson: 'person/proxyPerson',
      person: 'person/person'
    })
  },
  methods: {
    ...mapActions({
      updatePersonNote: 'person/updatePersonNote'
    })
  }
}
</script>
